import { FormaJuridicaEnum, type CreateEmpresaColaboradoraModel, type DireccionModel } from "@api/api";

export class CreateEmpresaColaboradora implements CreateEmpresaColaboradoraModel {

  Web: string = '';
  Documento: string = '';
  Telefono: string = '';
  Tipo: string = "COLABORADORES";
  RazonSocial: string = '';
  Email: string = '';
  FechaCreacion: Date = new Date(2000, 1, 1);
  RedesSociales: string | null = null;
  Direccion: DireccionModel = {
    CodigoPostal: null,
    Provincia: null,
    Municipio: null,
    TipoVia: null,
    NombreVia: null,
    Numero: null,
    Escalera: null,
    Piso: null,
    Puerta: null
  };
  Iban: string | null = null;
  FormaJuridica: FormaJuridicaEnum | null = null;
  PorcentajeIrpf: number | null = null;
  DiasAutofacturacion: number[] = [];
  ImagenB64: string | null = null;
  LogoPortalB64: string | null = null;
  DenoFactura: string = '';
  TieneWhitelistServicios: boolean = false;
  WhitelistServicios: string[] | null = null;
  MarcoComisiones: string | null = null;
  UsuarioResponsable: string | null = null;
  IdComercial: string | null = null;
  IdSubtipo: string | null = null;

  constructor(data?: Partial<CreateEmpresaColaboradora>) {
    Object.assign(this, data);
  }
}

